// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Material/components/WoodMaterial/components/styles.scss
// module id = 1358
// module chunks = 0